// extracted by mini-css-extract-plugin
export default {"main":"ScorePage_main__4gGM3","pageTitle":"ScorePage_pageTitle__mulAK","scoreSubTitle":"ScorePage_scoreSubTitle__0845-","scoreList":"ScorePage_scoreList__Oi+-n"};